import { render } from "./MaterialConsumption.vue?vue&type=template&id=30dc19c9&scoped=true"
import script from "./MaterialConsumption.vue?vue&type=script&lang=js"
export * from "./MaterialConsumption.vue?vue&type=script&lang=js"

import "./MaterialConsumption.vue?vue&type=style&index=0&id=30dc19c9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dc19c9"]])

export default __exports__